import {gql} from "@apollo/client";

export const GENERATE_PARCEL_DOWNLOAD_REPORT = gql`
    mutation GenerateParcelDownloadReport($filters: OrderFiltersTypeInput, $timezone: String) {
        generateParcelDownloadReport(filters: $filters, timezone: $timezone)
    }
`;

export interface GenerateParcelDownloadReportResponse {
    generateParcelDownloadReport: string;
}

export interface GenerateParcelDownloadReportVariables {
    filters?: any;
    timezone?: string;
}